
const vueOrg = {
  state: {
    vueOrgData: {},
    vueOrgCanExport: false,
  },

  mutations: {
    SET_VUEORGDATA: (state, val) => {
      state.vueOrgData = val
    },
    SET_VUEORGCANEXPORT: (state, val) => {
      state.vueOrgCanExport = val
    }
  },

  actions: {
    
  }
}

export default vueOrg
